module.exports = __webpack_public_path__ + "img/googleplay.5044a8bb.jpg";